module.exports = __webpack_public_path__ + "img/bottom.a8edb51d.svg";